<template>
  <!--MODAL BODY-->
  <div class="modalCar" @click="close" v-if="carrito">
    <!--MODAL CONTAINER-->
    <div class="modalc" @click.stop>
      <div class="carr-b">
        <!--TITLE-->
        <div class="tlc jcr">
          <img src="../../assets/cross.svg" alt="cross" class="cross" @click="close" />
        </div>
        <div class="tlc jcsb">
          <p class="title">CESTA ({{ carrito ? carrito.items.length : "" }})</p>
        </div>
        <div class="items" v-if="carrito.items.length > 0">
          <div class="tlc jcsb">
            <!-- <p class="title2">Envío gratis a partir de $1000</p> -->
          </div>

          <!--PRODUCT LIST-->
          <div class="prod-list" :class="{ scroll: carrito.items.length > 2, 'hgt': carrito.items.length < 2 }">
            <div class="product-c" v-for="(c, i) in carrito.items" :key="i">
              <!--PRODUCT INFO-->
              <div class="dflx proinfo">
                <img :src="url + 'product-img/' + c.item.image" alt="product" class="prod" v-if="c.item.image !== ''" />
                <img src="../../assets/noimg.png" alt="product" class="prod" v-else />
                <section>
                  <div class="dflx jcsb acomodo only-pc">
                    <p class="tl">${{ parseFloat(c.item.price * c.cantidad).toFixed(2) }}</p>
                    <div class="dflx wfit cant2">
                      <p class="tl">x {{ carrito.items[i].cantidad }}</p>
                     <!--
                        <input type="number" name="num2" id="num" class="tl" @click="selectC = i" v-model="c.cantidad"
                        :style="{
                          width:
                            (c.cantidad.toString().length == 1
                              ? 2.4
                              : 1.7 * (c.cantidad.toString().length == 0 ? 1 : c.cantidad.toString().length)) + 'vw',
                        }" min="1" :max="c.item.stock" />
                     -->
                    </div>
                  </div>
                  <div class="dflx jcsb acomodo only-mov">
                    <p class="tl">${{ parseFloat(c.item.price * c.cantidad).toFixed(2) }}</p>
                    <div class="dflx wfit cant2">
                      <p class="tl">x {{ carrito.items[i].cantidad }}</p>
                      <!--
                         <input type="number" name="num1" id="num" class="tl" @click="selectC = i" v-model="c.cantidad"
                        :style="{
                          width:
                            (c.cantidad.toString().length == 1
                              ? 8.7
                              : 7.7 * c.cantidad.toString().length) + 'vw',
                        }" min="1" :max="c.item.stock" />
                      -->
                    </div>
                  </div>
                  <div class="datainfo">
                    <div class="dflx">
                      <p class="tl2">{{ c.item.name }}</p>
                    </div>
                    <div class="dflx jcsb diferente">
                      <p class="tl2 green" v-for="(cc, j) in c.item.product_atributo_valores" :key="j">{{ cc.valor }}</p>
                      <div class="upd_cart">
                        <img src="../../assets/carrito/Arrow2.svg" alt="rest" @click="updateCarritoRest(i, carrito.items[i].cantidad)" />
                        
                        <img src="../../assets/carrito/Arrow1.svg" alt="add"  @click="updateCarritoAdd(i, carrito.items[i].cantidad)"/>
                      </div>
                     <!-- <div class="panel">
                        <img src="../../assets/panel1.svg" alt="edit" @click="actualizarCarrito(carrito)"
                          :class="{ eventBlock: selectC !== i, eventBlock: c.cantidad > c.item.stock, eventBlock: c.cantidad < 1 }" />
                        <img src="../../assets/panel2.svg" alt="delete" @click="deleteItem(i)" /> 
                      </div> -->
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <!--SUBTOTAL-->
          <input type="text" name="codigo" id="codigo" placeholder="AÑADIR CÓDIGO" class="textp"
            :class="{ 'act': cupon !== '', 'act': carrito.descupon !== 0 }" v-model="cupon" />
          <div class="btn-fc cupon" @click="aplicarCupon(cupon)" v-if="cupon !== ''">AGREGAR</div>
          <div class="textp dflx algc jcse panel" v-for="(cupon, index) in carrito.cupon" :key="index">
            <p class="c">#{{ cupon.code }}</p><img src="../../assets/panel2.svg" alt="delete"
              @click="deleteCupon(cupon.code)" class="pointer" />
          </div>
          <div v-if="status != ''" class="status_messages">
            <div v-if="status == 'success'" class="msg msg_success">
              <p>{{ message }}</p>
            </div>
            <div v-if="status == 'error'" class="msg msg_error">
              <p>{{ message }}</p>
            </div>
          </div>
          <div class="subt-c">
            <p>
              TOTAL: <span>${{ parseFloat(carrito.total).toFixed(2) }}</span>
            </p>
          </div>
          <!--FINALIZAR COMPRA-->
          <div class="dflx">
            <!--<div
            class="btn-fc yll"
            @click="actualizarCarrito(carrito)"
            :class="{ eventBlock: acta == false }"
          >
            Actualizar carrito
          </div>-->
            <div class="btn-fc" @click="toCheckout()">TRAMITAR PEDIDO</div>
          </div>
        </div>
        <div v-else>
          <div class="tlc jcsb">
            <p class="title2">Cesta vacía</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { url, endpointCodes } from "../../global/index";
import carrito from "../../store/modules/carrito";
export default {
  data() {
    return {
      url: url,
      endpointCodes,
      acta: false,
      selectC: null,
      cupon: "",
      status: "",
      message: "",
    };
  },
  async created() {
    await this.obtenerCarritos();
    await this.getIdentity();
  },
  computed: {
    carrito() {
      return this.$store.getters["carrito/getcar"];
    },
    update() {
      let data = this.$store.getters["carrito/getupd"];

      if (Array.isArray(data.items)) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].cantidad != this.carrito.items[i].cantidad) {
            this.upd = true;
            break;
          } else {
            this.upd = false;
          }
        }
      }
      return data;
    },
    identity() {
      return this.$store.getters["admin/getIdentity"];
    },
  },
  methods: {
    ...mapActions("carrito", ["getCart"]),
    ...mapActions("carrito", ["getCartCopy"]),
    ...mapActions("carrito", ["setAddedCrt2"]),

    delStatus: function () {
      setTimeout(() => this.delMsgs(), 2000);
    },
    delMsgs: function () {
      this.status = "";
      this.message = "";
    },
    close: async function () {
      //Regresar a la página
      //this.$emit("close");
      this.$emit("close");
      let payload3 = {
        mdc: 'none',
      }
      await this.setAddedCrt2(payload3)
    },
    async obtenerCarritos() {
      await this.getCart();
      await this.getCartCopy();
    },
    getIdentity: async function () {
      let response = await this.$store.dispatch("admin/getData");
      return response;
    },

    deleteItem: async function (index) {
      let payload = {
        index: index,
        _ctk: localStorage.getItem("_ctk"),
      };
      let result = await this.$store.dispatch("carrito/deleteItemCrt", {
        option: "del_item",
        item: payload,
      });
      if (result.status == "error") {
        this.status = "error";
        this.message = "Ha ocurrido un error al intentar eliminar el producto."; // result.message;
        this.delStatus();
      } else {
        // success

        this.status = "success";
        this.message = "Producto eliminado.";
        this.delStatus();
        //this.gotobasket();
        await this.obtenerCarritos();

        
        if(this.$route.path == "/mi-cuenta/escritorio") {
          location.reload();
        }
      }
    },
    gotobasket() {
      this.wait();
    },

    wait: function () {
      setTimeout(() => this.$router.go(), 200);
    },
    toCheckout: async function () {
      //await this.obtenerCarritos();
      let rescup = await this.aplicarCupon(this.cupon);

      if (rescup == "errore") {
        this.status = "error";
      } else {
        let payload = {
          carrito: this.carrito,
        };
        let result = await this.$store.dispatch("carrito/validateCrt", {
          option: "valid_cart",
          item: payload,
        });

        if (result.status == "error") {
          this.status = "error";
          this.message = result.message; // result.message;
          //this.delStatus();
        } else {
          // success
          //si todo esta correcto redireccionar.

          localStorage.getItem("lastv");
          localStorage.setItem("lastv", "car");
          localStorage.setItem("linked", "pro");
          //window.scrollTo(0, 0);
          this.$router.push("/check-out").catch((err) => { });
          return window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant",
          });
        }
      }
    },

    getAttr(c) {
      let attr = c.item.product_atributo_valores;
      if (!attr) return "";

      if (!Array.isArray(attr) || attr.length == 0) return "";

      if (!attr[0].valor || !attr[0].atributo) return "";

      return attr[0].valor;
    },

    updateCarritoRest: async function(i, cantidad){
     
      if(cantidad>1){
        this.carrito.items[i].cantidad = cantidad - 1
        this.actualizarCarrito(this.carrito)
      }else{
        //eliminar item
        this.deleteItem(i)
      }
    },
    updateCarritoAdd: async function(i, cantidad){
      this.carrito.items[i].cantidad = cantidad + 1
      this.actualizarCarrito(this.carrito)
    },
    actualizarCarrito: async function (carrito, key) {
      let payload = {
        carrito,
      };
      let result = await this.$store.dispatch("carrito/editItemCrt", {
        option: "upt_item",
        item: payload,
      });

      if (result.status == "error") {
        this.status = "error";
        if(result.message =='Ha superado el stock disponible para este producto.'){
          this.message = result.message
        }else{
          this.message =
          "Ha ocurrido un error al intentar actualizar el carrito.";
        }
       
        this.delStatus();
        // result.message;
        await this.obtenerCarritos();
      } else {
        // success
        this.selectC = null;
        await this.obtenerCarritos();
        this.status = "success";
        this.message = "Carrito actualizado";
        this.delStatus();
        this.acta = false;
        if (this.update.items.length == 0) {
          this.close();
        }
      }
    },
    reload() {
      window.history.go(-1);
    },

    /**cupon */

    aplicarCupon: async function (cupon) {
      //VDNQYUBWD6VNCM5OJ96X
      if (cupon != "") {
        let cliente = {
          sub: null,
          email: "",
        };
        if (this.identity?.sub) {
          cliente = this.identity;
        }

        let payload = {
          cupon,
          cliente,
          _ctk: localStorage.getItem("_ctk"),
        };
        let result = await this.$store.dispatch("carrito/editItemCrt", {
          option: "add_cupon",
          item: payload,
        });

        if (result.status == "error") {
          this.status = "error";/**/
          this.message = result.message;
          this.delStatus();
          return "errore"; // result.message;/**/
        } else {
          this.message = "Cupón agregado con éxito.";
          this.delStatus();/**/
          this.cupon = ''
          await this.obtenerCarritos();
        }
      }
    },
    deleteCupon: async function (cupon) {
      if (cupon != "") {
        let payload = {
          cupon,
          _ctk: localStorage.getItem("_ctk"),
        };
        let result = await this.$store.dispatch("carrito/deleteItemCrt", {
          option: "del_cupon",
          item: payload,
        });

        if (result.status == "error") {
          this.message = "error";
          this.message = result.message; // result.message;
          this.delStatus();
        } else {
          // success

          this.message = "success";
          this.message = "Cupón eliminado con éxito.";
          this.delStatus();
          await this.obtenerCarritos();
        }
      }
    },
  },
};
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
}

/* Desactivar flechas en Chrome */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.eventBlock {
  pointer-events: none;
  opacity: 0.5;
}

.modalCar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
}

.modalCar .modalc {
  background: #fff9ea;
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
}

.modalCar .carr-b {
  padding: 5.385vw 5.556vw 5.556vw;
}

.modalCar .tlc {
  display: flex;
  align-items: center;
}

.modalCar .tlc .title::before {
  font-family: "Catou";
  content: "*";
  color: #ff3723;
  font-weight: 300;
  font-size: 14.154vw;
  line-height: 0;
  position: relative;
  top: 4.2vw;
  margin: 0 3.451vw 0 0;
}

.modalCar .tlc .title {
  margin: 0;
  font-weight: 700;
  font-size: 6.154vw;
  line-height: 11.282vw;
  color: var(--co-tlMCar);
  font-family: var(--font-tlMCar);
}

.modalCar .tlc .title2 {
  margin: 3.846vw 0 0;
  font-weight: 700;
  font-size: 3.077vw;
  line-height: 5.641vw;
  color: var(--co-tlMCar);
  font-family: var(--font-tlMCar);
}

.modalCar .tlc .cross {
  width: 5.128vw;
  height: auto;
}

.modalCar .tlc .title span {
  margin-left: 5.072vw;
  padding: 2.415vw 4.348vw;
  background-color: var(--bk-cantMCar);
  color: var(--co-cantMCar);
  border-radius: 10vw;
}

.modalCar .prod-list.scroll {
  overflow-y: scroll;
}

.modalCar .prod-list {
  height: 76.13vw;
  padding-bottom: 10.513vw;
  border-bottom: 0.1vw solid transparent;
  overflow-y: scroll;
}

.modalCar .proinfo .prod {
  display: none;
}

.modalCar .proinfo section {
  width: 100%;
  padding-left: 0;
}

.modalCar .proinfo .tl {
  font-weight: 700;
  font-size: 5.556vw;
  line-height: 111%;
  color: var(--co-ptlMCar);
  font-family: var(--font-ptlMCar);
  margin: 0;
  text-align: center;
}

.modalCar .proinfo input.tl {
  width: 11vw;
  background: transparent;
  border: none;
}

.modalCar .proinfo .tl2 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 2.564vw;
  line-height: 4.615vw;
  color: var(--co-ptlMCar);
  font-family: var(--font-ptlMCar);
  margin: 1.795vw 0;
}

.modalCar .proinfo .tl2.green {
  color: var(--co-tlMCar);
}

.modalCar .subt-c p {
  font-family: var(--font-tlMCar);
  padding: 3.14vw 0 5.314vw;
  margin: 0;
  font-weight: 700;
  font-size: 3.077vw;
  line-height: 5.641vw;
  display: flex;
  justify-content: space-between;
  color: var(--co-sbtMCar);
}

.modalCar .subt-c span {
  font-size: 7.246vw;
  color: var(--co-sbtMCar);
}

.modalCar .btn-fc {
  width: 70.769vw;
  height: 8.974vw;
  border-radius: 15vw;
  margin: 8.205vw auto 0;
  display: flex;
  text-align: center;
  font-size: 3.077vw;
  line-height: 5.641vw;
  font-family: var(--font-tlMCar);
  border: 0.513vw solid var(--b-fcMCar);
  color: var(--b-fcMCar);
  background-color: transparent;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: .5s;
}

.modalCar .btn-fc.cupon {

  margin: 1.205vw auto;
}

.modalCar .btn-fc:hover {
  background-color: var(--co-ptlMCar);
  color: #fff9ea;
}


.modalCar .btn-fc.yll {
  background: var(--bk-fcMCarYll);
}

.modalCar .product-c {
  padding: 8.205vw 0 5.897vw;
  border-bottom: 0.256vw solid var(--co-ptlMCar);
}

.modalCar .panel img {
  width: 5.128vw;
  margin: 0 4vw;
  cursor: pointer;
}

.modalCar .textp {
  width: 70.769vw;
  height: 8.974vw;
  border-radius: 15vw;
  margin: 0 auto 9.538vw;
  /**/
  display: flex;
  text-align: left;
  font-size: 3.077vw;
  line-height: 5.641vw;
  font-family: var(--font-tlMCar);
  border: 0.513vw solid var(--b-fcMCar);
  color: var(--b-fcMCar);
  background-color: transparent;
}

.modalCar .textp.act {
  margin: 0 auto .138vw;
}

.modalCar .textp::placeholder {
  color: var(--b-fcMCar);
  text-align: center;
}

.modalCar .textp p {
  margin: 0;
}

.modalCar .textp.panel {
  margin: 3.538vw auto 3.538vw;
}

.modalCar .prod-list::-webkit-scrollbar {
  -webkit-appearance: none;
}

.modalCar .prod-list::-webkit-scrollbar:vertical {
  width: 1.2645833333333333vw;
  background-color: transparent;
  border-radius: 1.0416666666666665VW;
}

.modalCar .prod-list::-webkit-scrollbar-button:increment,
.modalCar .prod-list::-webkit-scrollbar-button {
  display: none;
}

.modalCar .prod-list::-webkit-scrollbar:horizontal {
  height: 1.2645833333333333vw;
}

.modalCar .prod-list::-webkit-scrollbar-thumb {
  background-color: var(--co-ptlMCar);
  border-radius: 1.0416666666666665VW;
  border: 0.10416666666666667vw solid var(--co-ptlMCar);
}

.modalCar .prod-list::-webkit-scrollbar-track {
  border-radius: 0.3645833333333333vw;
}

.upd_cart{
  
  display: flex;
  align-items: center;
  width: 5vw;
  justify-content: space-between;
}
.upd_cart img{
 width: 1.5vw;
 height: 1.5vw;
 cursor: pointer;
}

@media (max-width: 769px) {
  .upd_cart{

  width: 22vw;
}
.upd_cart img{
 width: 3vw;
 height: 5vw;
}
  .only-pc {
    display: none !important;
  }

  .only-mov {
    display: flex;
  }

  .modalCar .btn-fc.yll {
    width: 35.024vw;
  }
}

@media (min-width: 768px) {
  .modalCar .prod-list::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  .modalCar .prod-list::-webkit-scrollbar:vertical {
    width: 0.3645833333333333vw;
    background-color: transparent;
    border-radius: 1.0416666666666665VW;
  }

  .modalCar .prod-list::-webkit-scrollbar-button:increment,
  .modalCar .prod-list::-webkit-scrollbar-button {
    display: none;
  }

  .modalCar .prod-list::-webkit-scrollbar:horizontal {
    height: 0.3645833333333333vw;
  }

  .modalCar .prod-list::-webkit-scrollbar-thumb {
    background-color: var(--co-ptlMCar);
    border-radius: 1.0416666666666665VW;
    border: 0.10416666666666667vw solid var(--co-ptlMCar);
  }

  .modalCar .prod-list::-webkit-scrollbar-track {
    border-radius: 0.3645833333333333vw;
  }

  .only-pc {
    display: inherit;
  }

  .only-mov {
    display: none !important;
  }

  .diferente {
    margin-top: 0.8vw;
    display: flex;
    flex-wrap: wrap;
    width: 13vw;
  }

  .modalCar .proinfo .diferente .tl2 {
    width: 8vw;
  }

  .modalCar {
    left: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background: rgba(150, 150, 150, 0.8);
  }

  .modalCar .modalc {
    width: 28.646vw;
    margin-left: auto;
    position: relative;
    right: -40vw;
    transition: 0.75s;
  }

  .modalCar.transitionL .modalc {
    right: 0;
    overflow-y: auto;
  }

  .modalCar .carr-b {
    padding: 3.125vw 1.563vw 1.927vw;
  }

  .modalCar .tlc {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .modalCar .tlc .title,
  .modalCar .proinfo .tl,
  .modalCar .subt-c p {
    font-size: 1.042vw;
    line-height: 2.042vw;
  }

  .modalCar .tlc .title2 {
    margin: 1.667vw 0 0 3vw;
    font-size: 0.625vw;
    line-height: 1.146vw;
  }

  .modalCar .tlc .title span {
    padding: 0.521vw 0.938vw;
    margin-left: 1.094vw;
  }

  .modalCar .tlc .cross {
    display: block;
    width: 1.065vw;
    cursor: pointer;
  }

  .modalCar .proinfo input.tl {
    width: 2.4vw;
    padding: 0;
  }

  .modalCar .proinfo .tl2 {
    font-size: 0.625vw;
    line-height: 1.146vw;
    margin: 0;
  }

  .modalCar .panel {
    position: relative;
    top: -0.28vw;
  }

  .modalCar .panel img {
    width: 1.563vw;
    margin: 0 0.391vw;
    cursor: pointer;
  }

  .modalCar .proinfo .prod {
    display: block;
    width: 7.813vw;
    height: 7.813vw;
  }

  .modalCar .proinfo .sbtl {
    font-size: 0.729vw;
  }

  .modalCar .proinfo section {
    width: 15.521vw;
    padding-left: 0.885vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .modalCar .prod-list.scroll {
    overflow-y: scroll;
  }

  .modalCar .prod-list {
    height: 55.11111111111111vh;
    padding-bottom: 0;
    /*border-bottom: 0.1vw solid gainsboro;
    overflow-y: scroll;*/
  }

  .modalCar .prod-list.hgt {
    height: auto !important;
  }


  .modalCar .product-c {
    padding-top: 1.615vw;
    padding-bottom: 1.615vw;
    padding-left: 1vw;
    padding-right: 1vw;
    border-bottom: 0.1vw solid var(--co-ptlMCar);
    margin-bottom: 0;
  }

  .modalCar .product-c:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .modalCar .subt-c span {
    font-size: 1.563vw;
  }

  .modalCar .subt-c p {
    padding: 0;
  }

  .modalCar .btn-fc {
    width: 14.375vw;
    height: 2.656vw;
    font-size: 0.729vw;
    margin: 1.51vw auto 0;
    border: 0.104vw solid var(--co-ptlMCar);
  }

  .modalCar .tlc .title::before {
    font-size: 4.154vw;
    line-height: 0;
    position: relative;
    top: 1.62vw;
    margin: 0 1.451vw 0 0;
  }

  .modalCar .textp {
    width: 20.938vw;
    height: 2.604vw;
    font-size: 0.625vw;
    line-height: 1.146vw;
    border: 0.104vw solid var(--co-ptlMCar);
    border-radius: 5vw;
    margin: 1.51vw auto;
  }

  .modalCar .textp.panel {
    margin: 1.538vw auto 2.538vw;
  }

  .modalCar .cant2 {
    position: relative;
    left: 1vw;
  }
}</style>
